import React from "react";
import { Route } from "react-router-dom";
import ActivityRoute from "./activity";
import ApprovalRoute from "./approval";
import CustomerApprovalRoute from "./customer-approval";
import PrintRoute from "./print";
import TransactionUpdateRoute from "./transaction-update";

export default function LogRoutes( props ) {
    return (
    <Route path="/log">
      {ActivityRoute(props)}
      {ApprovalRoute(props)}
      {CustomerApprovalRoute(props)}
      {PrintRoute(props)}
      {TransactionUpdateRoute(props)}
    </Route>
    )
}